function isRemoteLogin({ state, output }) {
  let { remoteLogin } = state.get('client')
  if (remoteLogin) {
    output.true()
  } else {
    output.false()
  }
}

isRemoteLogin.outputs = ['true', 'false']
export default isRemoteLogin



// WEBPACK FOOTER //
// ./src/modules/client/actions/isRemoteLogin.js